export default class BBRange {
    #element
    #rangeEl
    #outputEl
    #outputText
    #timeout
    #updateDelay = 0
    #updateCallback = null
    #value = 0
    #min = 0
    #max = 0
    #init = false
    #outputCallback = null

    get element() {
        return this.#element;
    }

    get value(){
        return this.#value
    }

    get input(){
        return this.#rangeEl
    }

    constructor(element, updateDelay=0, updateCallback = null, outputCallback = null) {
        this.#element = element
        this.#rangeEl = element.querySelector('.range-input')
        this.#outputEl = element.querySelector('.output')
        this.#outputText = element.querySelector('.output-text')
        this.#min = this.#rangeEl.min
        this.#max = this.#rangeEl.max
        this.#updateDelay = updateDelay
        this.#outputCallback = outputCallback
        this.#updateCallback = updateCallback
        this.onRangeInput()
        this.#rangeEl.addEventListener('input', this.onRangeInput.bind(this))
        this.#init = true
    }

    onRangeInput() {
        clearTimeout(this.#timeout)
        this.#value = this.#rangeEl.value
        this.#rangeEl.setAttribute('value', this.#value)
        const valuePercent = `${100 - ((this.#max - this.#value) / (this.#max - this.#min) * 100)}%`;
        this.#outputText.textContent = typeof this.#outputCallback == 'function' ? this.#outputCallback(this.#value) : this.#value
        this.#outputEl.style.left = valuePercent;
        this.#outputEl.style.transform = `translateX(calc(-1 * ${valuePercent}))`
        this.#rangeEl.style.backgroundSize = `${valuePercent} 100%`;
        if(this.#init && typeof this.#updateCallback === 'function')
            this.#timeout = setTimeout(()=>this.#updateCallback(this), this.#updateDelay)
    }

    stopCallback(){
        clearTimeout(this.#timeout)
    }
}